/* ============================================================
   KaNi Candy - Warenkorb: Mischungen gruppieren
   Eine Mischung liegt als mehrere Zeilen im Warenkorb (Verpackung + je Sorte
   eine Zeile), verbunden ueber die Eigenschaft _mix_id. Fuer den Kunden soll
   das eine einzige Position sein. Dawns Zeilenmarkup bleibt unangetastet -
   wir gruppieren nur, was schon da ist.
   ============================================================ */
(function () {
  'use strict';

  var WURZEL = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  function geld(cent) {
    return (cent / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  function gruppiere(bereich) {
    var zeilen = bereich.querySelectorAll('tr[data-mix-id]');
    if (!zeilen.length) return;

    var gruppen = {};
    Array.prototype.forEach.call(zeilen, function (tr) {
      var id = tr.getAttribute('data-mix-id');
      (gruppen[id] = gruppen[id] || { container: null, teile: [] });
      if (tr.getAttribute('data-mix-role') === 'container') gruppen[id].container = tr;
      else gruppen[id].teile.push(tr);
    });

    Object.keys(gruppen).forEach(function (id) {
      var g = gruppen[id];
      if (!g.container || g.container.dataset.kaniFertig) return;
      g.container.dataset.kaniFertig = '1';

      var summe = 0;
      [g.container].concat(g.teile).forEach(function (tr) {
        summe += parseInt(tr.getAttribute('data-line-price') || '0', 10);
      });

      /* Shopify sortiert zuletzt Hinzugefuegtes nach oben, wodurch die
         Verpackung unter ihren Sorten landet. Die Karte muss aber ueber ihrem
         Inhalt stehen - also die Sortenzeilen direkt hinter den Container
         einsortieren, in ihrer urspruenglichen Reihenfolge. */
      var anker = g.container;
      g.teile.forEach(function (tr) {
        anker.parentNode.insertBefore(tr, anker.nextSibling);
        anker = tr;
      });

      /* --- Container-Zeile zur Mischungskarte machen --- */
      var name = g.container.querySelector('.cart-item__name');
      var details = g.container.querySelector('.cart-item__details');
      var props = g.container.querySelector('.product-option, dl');

      if (name) {
        name.textContent = 'Deine Mischung';
        name.classList.add('kani-mix__titel');
        name.removeAttribute('href');
      }

      if (details) {
        var zusatz = document.createElement('div');
        zusatz.className = 'kani-mix__meta';
        zusatz.innerHTML =
          '<span>' + g.teile.length + ' Sorten</span>' +
          '<button type="button" class="kani-mix__toggle" aria-expanded="false">Inhalt anzeigen</button>' +
          '<button type="button" class="kani-mix__weg">Entfernen</button>';
        details.appendChild(zusatz);

        zusatz.querySelector('.kani-mix__toggle').addEventListener('click', function () {
          var offen = this.getAttribute('aria-expanded') === 'true';
          this.setAttribute('aria-expanded', String(!offen));
          this.textContent = offen ? 'Inhalt anzeigen' : 'Inhalt ausblenden';
          g.teile.forEach(function (tr) { tr.classList.toggle('kani-mix__zeile--offen', !offen); });
        });

        zusatz.querySelector('.kani-mix__weg').addEventListener('click', function () {
          var btn = this;
          btn.disabled = true; btn.textContent = 'Wird entfernt …';
          var updates = {};
          [g.container].concat(g.teile).forEach(function (tr) {
            var k = tr.getAttribute('data-line-key');
            if (k) updates[k] = 0;
          });
          fetch(WURZEL + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates })
          })
            .then(function (r) { if (!r.ok) throw new Error('Fehler'); return r.json(); })
            .then(function () { window.location.reload(); })
            .catch(function () {
              btn.disabled = false; btn.textContent = 'Entfernen';
            });
        });
      }

      /* Gruppenpreis in beide Preiszellen schreiben (mobil und Desktop) */
      Array.prototype.forEach.call(g.container.querySelectorAll('.cart-item__totals'), function (td) {
        var preis = td.querySelector('.cart-item__final-price, .price');
        if (preis) preis.textContent = geld(summe);
      });

      /* Der Einzelpreis der Verpackung stiftet neben der Gruppensumme nur
         Verwirrung - er gehoert in die aufgeklappte Liste, nicht in die Karte. */
      var einzel = g.container.querySelector('.cart-item__price-wrapper');
      if (einzel) einzel.classList.add('kani-mix__aus');

      /* "Inhalt" und "Groesse" stehen schon im Titel bzw. in der aufklappbaren
         Liste. Am Auftrag bleiben die Eigenschaften erhalten - sie sind die
         Packliste fuers Lager -, nur die Anzeige wird entdoppelt. */
      Array.prototype.forEach.call(g.container.querySelectorAll('.product-option'), function (opt) {
        var dt = opt.querySelector('dt');
        if (!dt) {
          /* Ohne Beschriftung ist es Dawns Einzelpreis-Anzeige. */
          if (opt.parentElement === details) opt.classList.add('kani-mix__aus');
          return;
        }
        var label = dt.textContent.replace(':', '').trim();
        if (label === 'Inhalt' || label === 'Größe') opt.classList.add('kani-mix__aus');
      });

      /* Mengenfeld der Verpackung ausblenden: eine Mischung ist eine Einheit.
         Die Menge einzeln zu aendern wuerde Verpackung und Inhalt entkoppeln. */
      var menge = g.container.querySelector('.cart-item__quantity');
      if (menge) menge.classList.add('kani-mix__menge-aus');

      /* --- Sortenzeilen einklappen --- */
      g.teile.forEach(function (tr) {
        tr.classList.add('kani-mix__zeile');
        var m = tr.querySelector('.cart-item__quantity');
        if (m) m.classList.add('kani-mix__menge-aus');
        /* Sorten kosten einzeln nichts - die Tuete hat einen Festpreis. Statt
           "0,00 EUR" in jeder Zeile steht dort gar kein Preis. Die Zellen
           bleiben stehen, damit die Tabelle ihre Spalten behaelt. */
        Array.prototype.forEach.call(tr.querySelectorAll('.cart-item__price-wrapper'), function (el) {
          el.classList.add('kani-mix__menge-aus');
        });
        Array.prototype.forEach.call(tr.querySelectorAll('.cart-item__details > .product-option, .cart-item__discounted-prices'), function (el) {
          if (!el.querySelector('dt')) el.classList.add('kani-mix__aus');
        });
      });
    });
  }

  function start() {
    gruppiere(document);
  }

  document.addEventListener('DOMContentLoaded', start);
  if (document.readyState !== 'loading') start();

  /* Dawn tauscht Warenkorb-Abschnitte per fetch aus. Danach neu gruppieren. */
  var beobachter = new MutationObserver(function (m) {
    for (var i = 0; i < m.length; i++) {
      if (m[i].addedNodes.length) { gruppiere(document); break; }
    }
  });
  beobachter.observe(document.documentElement, { childList: true, subtree: true });
})();
